module.exports = __webpack_public_path__ + "img/0030.799e7599.jpg";